import type { PaginationParams } from '@/types/common';

export const favouriteKeys = {
  all: ['recipe-favourites'] as const,
  lists: () => [...favouriteKeys.all, 'list'] as const,
  list: (params?: PaginationParams) => [...favouriteKeys.lists(), params ?? {}] as const,
  status: (recipeId: number) => [...favouriteKeys.all, 'status', recipeId] as const,
};
